import { QueryOptions } from '@tanstack/react-query';

import { getOrCreateQueryClient } from './iwQueryClient';

export function fetchQueryClient(queryOptions: QueryOptions) {
    const queryClient = getOrCreateQueryClient();
    const promise = queryClient.fetchQuery(queryOptions);
    return () => promise;
}
